export default {
  namespaced: true,

  state: {
    enabled: false,
    key: '',
    actions: [],
    loadPromise: null,
    loading: false,
    loaded: false,
    ready: false,
  },

  getters: {
    isEnabled(state) {
      return state.enabled === true
    },

    key(state) {
      return state.key
    },

    actions(state) {
      return state.actions
    },

    isLoading(state) {
      return state.loading === true
    },

    isLoaded(state) {
      return state.loaded === true
    },

    isReady(state) {
      return state.ready === true
    },
  },

  mutations: {
    setEnabled(state, enabled) {
      state.enabled = enabled
    },

    setKey(state, key) {
      state.key = key
    },

    setActions(state, actions) {
      state.actions = actions
    },

    setLoading(state, loading) {
      state.loading = loading
    },

    setLoaded(state, loaded) {
      state.loaded = loaded
    },

    setReady(state, ready) {
      state.ready = ready
    },

    setLoadPromise(state, p) {
      state.loadPromise = p;
    }
  },

  actions: {
    init({ commit, getters }, settings) {
      return new Promise((resolve, reject) => {
        if (getters.ready || getters.loaded) {
          return resolve()
        } else if (getters.loading) {
          return reject({ message: 'reCAPTCHA is already loading.' })
        }

        commit('setEnabled', settings.enabled)
        commit('setKey', settings.key)
        commit('setActions', settings.enabled ? settings.actions.map(action => action.id) : [])

        if (settings.enabled === false) {
          commit('setReady', false)
          commit('setLoaded', false)
          commit('setLoading', false)
          return
        }

        commit('setReady', false)
        commit('setLoaded', false)
        commit('setLoading', true)

        let resolveLoadPromise, rejectLoadPromise;

        const loadPromise = new Promise((resolve, reject) => {
          resolveLoadPromise = resolve;
          rejectLoadPromise = reject;
        });

        commit('setLoadPromise', loadPromise);

        const script = document.createElement('script')
        script.src = `https://www.google.com/recaptcha/api.js?render=${settings.key}`
        script.onload = () => {
          commit('setLoaded', true)
          commit('setLoading', false)

          window.grecaptcha.ready(() => {
            commit('setReady', true)
            resolveLoadPromise(window.grecaptcha);
            resolve()
          })
        }
        script.onerror = err => {
          commit('setReady', false)
          commit('setLoaded', true)
          commit('setLoading', true)
          rejectLoadPromise(err);
          commit('setLoadPromise', null);
          reject({ message: 'reCAPTCHA script was not loaded.', err })
        }

        document.getElementsByTagName('head')[0].appendChild(script)
      })
    },

    async getToken({ state, getters }, action) {
      if (!getters.isEnabled || !getters.actions.includes(action)) {
        console.log('reCAPTCHA is not enabled to actions is not in allowed actions list', {
          action,
          enabed: getters.isEnabled,
          actions: getters.actions,
        })
        return null;
      }

      if (!getters.isReady) {
        await state.loadPromise;
      }

      return window.grecaptcha.execute(getters.key, { action })
    }
  }
}
